import * as React from "react";

interface Props {
  children?: React.ReactNode;
}

export default function AccordionPartHelper({ children }: Props) {
  return <div>{children}</div>;
}
